import React, { useState } from "react";
import {
  Box,
  Container,
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography
} from "@mui/material";
// import { Box, Container } from "@mui/material";
import { Formik, Form } from "formik";
import { useDispatch } from "react-redux";
import { register } from "../../../../core/redux/action/auth";
import LoadingButton from "@mui/lab/LoadingButton";

import PersonalInformation1 from "./Forms/PersonalInformation1";
import PersonalInformation2 from "./Forms/PersonalInformation2";
import EducationBackground from "./Forms/EducationalBackground";
import WorkingExperience from "./Forms/WorkingExperience";

import RegisterSuccessPhD from "./RegisterSuccess";

import validationSchema from "./FormModel/validationSchema";
import phdFormModel from "./FormModel/phdFormModel";
import formInitialValues from "./FormModel/formInitialValues";

import useStyles from "./styles";

const steps = [
  "Personal Information",
  "PhD Student Information",
  "Education Background",
  "Working Experience"
];
const { formId, formField } = phdFormModel;
const phd_3y = "normalCourse3yrs";

function _renderStepContent(step) {
  switch (step) {
    case 0:
      return <PersonalInformation1 formField={formField} />;
    case 1:
      return <PersonalInformation2 formField={formField} />;
    case 2:
      return <EducationBackground formField={formField} />;
    case 3:
      return <WorkingExperience formField={formField} />;
    default:
      return <>Not Found</>;
  }
}

export default function RegisterPhDPage() {
  const dispatch = useDispatch();

  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const currentValidationSchema = validationSchema[activeStep];
  const isLastStep = activeStep === steps.length - 1;

  function _sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function _submitForm(values, actions) {
    var formData = new FormData();

    for (const [key, value] of Object.entries(values)) {
      if (value?.file) {
        formData.append(key, value.file);
      } else {
        if (Array.isArray(value)) {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value ? value : "");
        }
      }
    }
    //phd
    formData.append("role", values.c2fScholarshipProgram === phd_3y ? 2 : 3);

    dispatch(register(formData));

    await _sleep(1000);
    actions.setSubmitting(false);
    setActiveStep(activeStep + 1);
  }

  function _handleSubmit(values, actions) {
    if (isLastStep) {
      _submitForm(values, actions);
    } else {
      setActiveStep(activeStep + 1);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  }

  function _handleBack() {
    setActiveStep(activeStep - 1);
  }

  return (
    <Container>
      <Box sx={{ textAlign: "center" }}>
        <>
          <Typography component="h1" variant="h4" align="center">
            Registration for C2F PhD Student
          </Typography>
          <Stepper activeStep={activeStep} className={classes.stepper}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length ? (
            <RegisterSuccessPhD />
          ) : (
            <Formik
              initialValues={formInitialValues}
              validationSchema={currentValidationSchema}
              onSubmit={_handleSubmit}
            >
              {({ isSubmitting }) => {
                return (
                  <Form id={formId}>
                    {_renderStepContent(activeStep)}

                    <Box className={classes.buttons}>
                      {activeStep !== 0 && (
                        <Button
                          onClick={_handleBack}
                          className={classes.button}
                        >
                          Back
                        </Button>
                      )}
                      <Box className={classes.wrapper}>
                        <LoadingButton
                          loading={isSubmitting}
                          disabled={isSubmitting}
                          type="submit"
                          variant="contained"
                          color="primary"
                          className={classes.button}
                        >
                          {isLastStep ? "Submit" : "Next"}
                        </LoadingButton>
                      </Box>
                    </Box>
                  </Form>
                );
              }}
            </Formik>
          )}
        </>
      </Box>
    </Container>
  );
}
